import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useAppSelector } from '@/redux/store';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';
import { ROUTES } from '@/routes';
import {
  createMembershipPaymentResultPath,
  getPaymentResultIdFromResponse,
} from '@/utils/membership-payment-result';

const KakaopayChangeApproval = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mutate: approveKakaoPay } = usePost(CPLAT_API_ROUTES.setSubscriptionForKakaopay);
  const { CplatToken } = useAppSelector((state) => state.user);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pgToken = params.get('pg_token');
    const kakaoPayRequestInfo = JSON.parse(localStorage.getItem('kakaoPayRequestInfo') || '{}');
    const kakaoPayResponseInfo = JSON.parse(localStorage.getItem('kakaoPayResponseInfo') || '{}');
    // const subscriptionNo = kakaoPayRequestInfo?.SubscriptionNo;
    const subscriptionNo = Number(localStorage.getItem('subscriptionNo'));

    if (pgToken) {
      approveKakaoPay(
        {
          cplatToken: CplatToken,
          subscriptionNo,
          pgToken,
          kakaoPayRequestInfo,
          kakaoPayResponseInfo,
        },
        {
          onSuccess: (response) => {
            const paymentResultId = getPaymentResultIdFromResponse(response);

            // 결제 성공 안내 및 구독정보 갱신
            localStorage.removeItem('kakaoPayPaymentChange');
            navigate(
              createMembershipPaymentResultPath({
                path: ROUTES.moreMembership,
                result: 'success',
                paymentChange: true,
                paymentResultId,
              }),
            );
          },
          onError: () => {
            localStorage.removeItem('kakaoPayPaymentChange');
            navigate(`${ROUTES.moreMembership}?result=fail&paymentChange=true`);
          },
        },
      );
    }
  }, [CplatToken, approveKakaoPay, location.search, navigate]);

  return <GlobalSpinner />;
};

export default KakaopayChangeApproval;
